import { Fragments } from "requests";

export const getDefaultValues = (exam: Fragments.StoredPhysicalExam) => {
  return {
    generalAppearance: exam?.generalAppearance || null,
    gastrointestinal: exam?.gastrointestinal || null,
    oralCavity: exam?.oralCavity || null,
    musculosceletal: exam?.musculosceletal || null,
    mucousMembranes: exam?.mucousMembranes || null,
    lymphNodes: exam?.lymphNodes || null,
    eyes: exam?.eyes || null,
    urogenital: exam?.urogenital || null,
    ears: exam?.ears || null,
    integumentary: exam?.integumentary || null,
    cardiovascular: exam?.cardiovascular || null,
    nervousSystem: exam?.nervousSystem || null,
    respiratory: exam?.respiratory || null
  };
};
